export default __webpack_public_path__ + "static/media/502.b071ec8a.png";